import { render } from "./StockRegisterTable.vue?vue&type=template&id=1b329007&scoped=true"
import script from "./StockRegisterTable.vue?vue&type=script&lang=js"
export * from "./StockRegisterTable.vue?vue&type=script&lang=js"

import "./StockRegisterTable.vue?vue&type=style&index=0&id=1b329007&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b329007"]])

export default __exports__